import {Component, effect, Injector, Input, OnInit, signal, ViewEncapsulation} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';

import {isRunInProgress} from '../../models/run';
import {AiChatService} from '../../services/ai-chat.service';

@Component({
  selector: 'ai-chat-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InputComponent implements OnInit {
  readonly loading = signal(false);
  private lastMessage = signal<string>(null);
  readonly isAssistantEnabled = this.aiChatService.isAssistantEnabled;

  @Input() set triggerResetInput(_: boolean) {
    if (!this.control.value) {
      this.control.markAsUntouched();
    }
  }

  control = new FormControl(
    '',
    Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(32000)])
  );

  constructor(
    private injector: Injector,
    private aiChatService: AiChatService
  ) {}

  ngOnInit() {
    this.initStatusObserver();
    this.initAssistantObserver();
  }

  public processMessage() {
    const message = this.control.value.trim();

    if (this.control.invalid || !message) {
      return void 0;
    }

    this.resetMessageControl();
    this.lastMessage.set(message);
    this.aiChatService.processMessage(message);
  }

  private resetMessageControl(value: string = '') {
    this.control.reset({value, disabled: !this.isAssistantEnabled()});

    if (value) {
      this.lastMessage.set(null);
    }
  }

  private initStatusObserver() {
    effect(
      () => {
        const status = this.aiChatService.status();
        const inProgress = isRunInProgress(status);
        const isSucceeded = status === 'completed';

        this.loading.set(inProgress);

        if (!inProgress) {
          this.resetMessageControl(isSucceeded ? '' : this.lastMessage());
        } else {
          this.control.disable();
        }
      },
      {injector: this.injector, allowSignalWrites: true}
    );
  }

  private initAssistantObserver() {
    effect(
      () => {
        this.resetMessageControl();
        this.lastMessage.set(null);
      },
      {injector: this.injector, allowSignalWrites: true}
    );
  }
}
